// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapIcon } from '../../../../dsl/front';
let ArticleActionItem = class ArticleActionItem extends Vue {
    get displayedLabel() {
        return this.label || this.title;
    }
};
__decorate([
    Prop({ type: String, required: true })
], ArticleActionItem.prototype, "icon", void 0);
__decorate([
    Prop({ type: String, required: true })
], ArticleActionItem.prototype, "title", void 0);
__decorate([
    Prop({ type: String, required: false })
], ArticleActionItem.prototype, "label", void 0);
__decorate([
    Prop({ type: String, required: false })
], ArticleActionItem.prototype, "className", void 0);
__decorate([
    Prop({ type: Function, required: true })
], ArticleActionItem.prototype, "callback", void 0);
ArticleActionItem = __decorate([
    Component({
        name: 'ArticleActionItem',
        components: { BootstrapIcon },
        template: `
    <li>
      <button class="article-actions__list__item" :class="className" :title="title" @click="callback">
        <BootstrapIcon :name="icon" size="medium" />
        {{ displayedLabel }}
      </button>
    </li>
  `
    })
], ArticleActionItem);
export { ArticleActionItem };
export default ArticleActionItem;
